import Vue from 'vue';

Vue.directive('test', {
    inserted(el, {arg}) {
        if (window.webpackHotUpdate || window.Cypress) {
            el.dataset.cy = arg;
        }
    },
});
